/* eslint-disable import/no-anonymous-default-export */
import Workflows from "./Workflows";
import Placeholders from "./Placeholders";
export default {
    id: 105,
    title: 'Notifications',
    path: 'notifications',
    icon: "flaticon2-bell-2",
    workflows: Workflows,
    placeholders: Placeholders,
};